import React from 'react'

import { useIntl } from 'react-intl'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import {
  Button,
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot
} from 'mailup-web-components'

import { modalSendingMessageState } from '../../recoil/state/modals'
const ModalSendingMessage = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalSendingMessageState)
  const handleClose = useResetRecoilState(modalSendingMessageState)

  return (
    <Modal
      show={show}
      onClose={handleClose}
      showClose
      closeOnOverlayClick
      data-mu-test='sending-message-modal'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.EmailMessageList.MessageIsOnSentWarningTitle'
        })}
      />
      <ModalBody>
        <p>
          {intl.formatMessage({
            id: 'Load.EmailMessageList.MessageIsOnSentWarning'
          })}
        </p>
      </ModalBody>
      <ModalFoot>
        <Button
          kind='primary'
          onClick={handleClose}
          data-mu-test='sending-message-modal__confirm'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Ok' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalSendingMessage
